'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n    width: 16px;\n    height: 16px;\n    border-radius: 2px;\n  '], ['\n    width: 16px;\n    height: 16px;\n    border-radius: 2px;\n  ']),
    _templateObject2 = _taggedTemplateLiteral(['\n    width: 24px;\n    height: 24px;\n    border-radius: 3px;\n  '], ['\n    width: 24px;\n    height: 24px;\n    border-radius: 3px;\n  ']),
    _templateObject3 = _taggedTemplateLiteral(['\n    width: 32px;\n    height: 32px;\n    border-radius: 4px;\n  '], ['\n    width: 32px;\n    height: 32px;\n    border-radius: 4px;\n  ']),
    _templateObject4 = _taggedTemplateLiteral(['\n  display: inline-block;\n  cursor: ', ';\n  opacity: ', ';\n  overflow: hidden;\n  position: relative;\n  background-color: ', ';\n  user-select: none;\n\n  ', ';\n\n  ', ';\n'], ['\n  display: inline-block;\n  cursor: ', ';\n  opacity: ', ';\n  overflow: hidden;\n  position: relative;\n  background-color: ', ';\n  user-select: none;\n\n  ', ';\n\n  ', ';\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _polished = require('polished');

var _colors = require('../../../libs/colors');

var colors = _interopRequireWildcard(_colors);

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
} // Styles


var sizes = {
  small: (0, _styledComponents.css)(_templateObject),
  normal: (0, _styledComponents.css)(_templateObject2),
  large: (0, _styledComponents.css)(_templateObject3)
};

var getBgColorOn = function getBgColorOn(green) {
  return green ? colors.green : colors.red;
};

var CheckBoxContainer = _styledComponents2.default.div(_templateObject4, function (_ref) {
  var disabled = _ref.disabled;
  return disabled ? 'not-allowed' : 'pointer';
}, function (_ref2) {
  var disabled = _ref2.disabled;
  return disabled ? 0.6 : 1;
}, function (_ref3) {
  var on = _ref3.on,
      green = _ref3.green,
      disabled = _ref3.disabled;
  return !on || disabled ? colors.grey : getBgColorOn(green);
}, (0, _polished.transitions)('background-color .2s ease-in-out'), function (_ref4) {
  var size = _ref4.size;
  return sizes[size];
});

CheckBoxContainer.propTypes = {
  on: _propTypes2.default.number,
  size: _propTypes2.default.string,
  disabled: _propTypes2.default.bool,
  green: _propTypes2.default.bool
};
exports.default = CheckBoxContainer;